import { makeStyles, Theme } from '@material-ui/core/styles';

import { checkboxColor, orangered } from 'styles/abstract/variables';

export const makeCheckboxStyles = makeStyles(
    (theme: Theme) => ({
        root: {
            color: checkboxColor,
            marginRight: theme.spacing(0.5),
            padding: 0,

            '&$checked': {
                color: checkboxColor,
            },
        },
        checked: {},
    }),
    { index: 1 },
);

export const makeCheckboxRequiredStyles = makeStyles(
    {
        root: {
            '&::after': {
                content: "'*'",
                fontSize: '1rem',
                color: orangered,
            },
        },
    },
    { index: 1 },
);
